import { createContext } from 'react';

export interface IUserSettings {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  isLoading: boolean;
}

export const UserSettingsContext = createContext<IUserSettings>({
  sidebarOpen: true,
  toggleSidebar: () => null,
  isLoading: false,
});
